import { fetchWithTimeout } from '../tools';
import { getProfilEndPoint, getSigninEndPoint } from '../endpoint';
import { STORAGE_DOES_NOT_EXIST, STORAGE_NO_SPACE } from '../constants';

export const errorClosing = 'Error while closing recording';
export const errorSending = 'Error while sending chunk';
export const errorInit = 'Error while init sending chunk';

export const checksTypes = {
	os: 'os',
	browser: 'browser',
	browserVersion: 'browserVersion',
	haveJs: 'haveJs',
	haveWebRtc: 'haveWebRtc',
	bandwidthDown: 'bandwidthDown',
	bandwidthUp: 'bandwidthUp',
	haveRTCAccess: 'haveRtcAccess',
	haveIceAccess: 'haveIceAccess',
	haveCam: 'haveCam',
	haveMic: 'haveMic',
	devicesAuth: 'devicesAuth',
	micId: 'micId',
	webcamId: 'webcamId',
	canRecordRTC: 'canRecordRtc',
	haveMediaRecorder: 'haveMediaRecorder',
};

export const checkStatusDevice = {
	noDevice: (device) => !device,
	prompt: (device) => device === 'prompt',
	denied: (device) => device === 'denied',
};

export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export const stopVideo = (ref) => {
	const stream = ref?.video?.srcObject;

	if (!stream) {
		return null;
	}
	const tracks = stream?.getTracks();

	tracks?.forEach((track) => track.stop());
	ref.video.srcObject = null;
	return null;
};

export async function refreshCandidateSession(
	apiCall,
	method,
	{ tokenApi = null, emailApi = null } = {}
) {
	try {
		const localToken = tokenApi ?? JSON.parse(localStorage.getItem('localToken'));
		const dataToken = JSON.stringify({ token: localToken });
		const res = await fetchWithTimeout(getSigninEndPoint, {
			method: 'POST',
			body: dataToken,
		});

		if (res.ok) {
			try {
				const email = emailApi ?? JSON.parse(localStorage.getItem('email'));

				if (email) {
					const dataEmail = JSON.stringify({ email });
					const resEmail = await fetchWithTimeout(getProfilEndPoint, {
						method: 'PATCH',
						body: dataEmail,
					});

					if (resEmail.ok) {
						const newCall = await fetchWithTimeout(apiCall, method);

						return newCall.ok;
					}
					return false;
				}
				const newCall = await fetchWithTimeout(apiCall, method);

				return newCall.ok;
			} catch (err) {
				const newCall = await fetchWithTimeout(apiCall, method);

				return newCall.ok;
			}
		}
		return false;
	} catch (err) {
		console.log(err);
	}
	return false;
}

/**
 *
 * @returns {Promise<'STORAGE_DOES_NOT_EXIST'| 'OK' | 'STORAGE_NO_SPACE'>}
 */
export const estimateSpaceRemaining = async () => {
	if (!navigator.storage || !navigator.storage.estimate) return STORAGE_DOES_NOT_EXIST;

	const required = 20, // MB required
		estimate = await navigator.storage.estimate(),
		// calculate remaining storage in MB
		available = Math.floor((estimate.quota - estimate.usage) / 1024 / 1024);

	if (available >= required) {
		console.log('Storage is available');
		// ...call functions to initialize IndexedDB
		return 'OK';
	}
	return STORAGE_NO_SPACE;
};
